import { EntityTypes } from "./enums";
import { SupplierRequestNAICS } from "./supplierRequest";
import { Supplier } from './supplier';
import { SourcingRequirement } from './sourcingRequest';

export interface SourcingRequestMatch {
  requestId: string;
  matchId: string;
  entityType: EntityTypes.sourcingRequestMatch;
  orgName: string;
  orgId: string;
  industry: string;
  location: string;
  website: string;
  contactPerson?: string;
  yearsInBusiness?: string;
  certifications?: string;
  naicsMatch?: SupplierRequestNAICS[];
  supplierMatchScore?: number;
  productsAndServicesMatches?: SourcingRequestMatchScoreAndJustification[];
  productsAndServicesScore?: number;
  demographicMatches?: SourcingRequestMatchScoreAndJustification[];
  demographicScore?: number;
  geographicMatches?: SourcingRequestMatchScoreAndJustification[];
  geographicScore?: number;
  regulatoryMatches?: SourcingRequestMatchScoreAndJustification[];
  regulatoryScore?: number;
  industryMatches?: SourcingRequestMatchScoreAndJustification[];
  industryScore?: number;
  otherRequirementsMatches?: SourcingRequestMatchScoreAndJustification[];
  otherRequirementsScore?: number;
  locationMatches?: SourcingRequestMatchScoreAndJustification[];
  locationScore?: number;
  logisticsMatches?: SourcingRequestMatchScoreAndJustification[];
  logisticsScore?: number;
  qualifiedMatch?: boolean;
  canceled?: boolean;
  created: number;
  lastUpdated: number;
}

export interface SourcingRequestMatchCandidate {
  requestId: string;
  orgId: string;
  orgHash: string;
  supplier: Supplier;
  naicsCodeMatch?: SupplierRequestNAICS[];
  productAndServicesMatches?: SourcingRequirement[];
  geographiesMatches?: SourcingRequirement[];
  industriesMatches?: SourcingRequirement[];
  demographicMatches?: SourcingRequirement[];
  locationMatches?: {
    location: string;
    distance: number;
  }[];
  expires?: number;
}

export interface CreateSourcingRequestMatchInput {
  requestId: string;
  orgName: string;
  orgId: string;
  industry: string;
  location: string;
  website: string;
  contactPerson?: string;
  yearsInBusiness?: string;
  certifications?: string;
  naicsMatch?: SupplierRequestNAICS[];
  supplierMatchScore?: number;
  productsAndServicesMatches?: SourcingRequestMatchScoreAndJustification[];
  productsAndServicesScore?: number;
  demographicMatches?: SourcingRequestMatchScoreAndJustification[];
  demographicScore?: number;
  geographicMatches?: SourcingRequestMatchScoreAndJustification[];
  geographicScore?: number;
  regulatoryMatches?: SourcingRequestMatchScoreAndJustification[];
  regulatoryScore?: number;
  industryMatches?: SourcingRequestMatchScoreAndJustification[];
  industryScore?: number;
  otherRequirementsMatches?: SourcingRequestMatchScoreAndJustification[];
  otherRequirementsScore?: number;
  locationMatches?: SourcingRequestMatchScoreAndJustification[];
  locationScore?: number;
  logisticsMatches?: SourcingRequestMatchScoreAndJustification[];
  logisticsScore?: number;
  qualifiedMatch?: boolean;
}

export interface SourcingRequestMatchScoreAndJustification {
  requirement: string;
  canMeetRequirement: boolean;
  justification: string;
  confidence: number;
}

export interface UpdateSourcingRequestMatchScoreInput {
  matchId?: string;
  supplierMatchScore?: number;
  productsAndServicesScore?: number;
  demographicScore?: number;
  geographicScore?: number;
  regulatoryScore?: number;
  industryScore?: number;
  otherRequirementsScore?: number;
  locationScore?: number;
  logisticsScore?: number;
  qualifiedMatch?: boolean;
}

export interface UpdateSourcingRequestMatchScoreJustificationInput {
  matchId?: string;
  productsAndServicesMatches?: SourcingRequestMatchScoreAndJustification[];
  demographicMatches?: SourcingRequestMatchScoreAndJustification[];
  geographicMatches?: SourcingRequestMatchScoreAndJustification[];
  regulatoryMatches?: SourcingRequestMatchScoreAndJustification[];
  industryMatches?: SourcingRequestMatchScoreAndJustification[];
  otherRequirementsMatches?: SourcingRequestMatchScoreAndJustification[];
  locationMatches?: SourcingRequestMatchScoreAndJustification[];
  logisticsMatches?: SourcingRequestMatchScoreAndJustification[];
}

export interface SourcingRequestMatchScoreMessage {
  url: string;
  companyName: string;
  orgHash: string;
  productsAndServicesRequirements?: string[];
  logisticsRequirements?: string[];
  regulatoryRequirements?: string[];
  otherRequirements?: string[];
  matchId: string;
}

export interface SourcingRequestMatchScorePublishedMessage {
  url: string;
  companyName: string;
  orgHash: string;
  productsAndServicesMatches?: SourcingRequestMatchScoreAndJustification[];
  logisticsMatches?: SourcingRequestMatchScoreAndJustification[];
  regulatoryMatches?: SourcingRequestMatchScoreAndJustification[];
  otherRequirementsMatches?: SourcingRequestMatchScoreAndJustification[];
  matchId: string;
  error?: boolean;
  errorMessage?: string;
}
